import { Link } from 'react-router-dom';

const platforms = [
  { name: 'Taobao Spreadsheet', to: '/taobao-spreadsheet', icon: 'ri-shopping-bag-line', desc: 'Поиск товаров на крупнейшем китайском маркетплейсе' },
  { name: 'Weidian Spreadsheet', to: '/weidian-spreadsheet', icon: 'ri-store-line', desc: 'Редкие находки и эксклюзивные товары' },
  { name: '1688 Spreadsheet', to: '/1688-spreadsheet', icon: 'ri-building-2-line', desc: 'Оптовые закупки напрямую от производителей' },
  { name: 'Yoybuy Spreadsheet', to: '/yoybuy-spreadsheet', icon: 'ri-shopping-cart-line', desc: 'Таблицы для агента Yoybuy' },
  { name: 'Kakobuy Spreadsheet', to: '/kakobuy-spreadsheet', icon: 'ri-smartphone-line', desc: 'Оптимизировано для Kakobuy' },
  { name: 'Superbuy Spreadsheet', to: '/superbuy-spreadsheet', icon: 'ri-building-line', desc: 'Проверенные таблицы для Superbuy' },
  { name: 'Pandabuy Spreadsheet', to: '/pandabuy-spreadsheet', icon: 'ri-group-line', desc: 'Таблицы сообщества Pandabuy' },
  { name: 'Sugargoo Spreadsheet', to: '/sugargoo-spreadsheet', icon: 'ri-money-dollar-circle-line', desc: 'Максимальная экономия с Sugargoo' },
  { name: 'Mulebuy Spreadsheet', to: '/mulebuy-spreadsheet', icon: 'ri-rocket-line', desc: 'Инновационный агент Mulebuy' },
];

export default function PlatformsSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-700 mb-4">
            Спредшиты
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">
            Спредшиты для платформ и агентов
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Подробные руководства по использованию таблиц товаров для всех популярных китайских платформ и агентов доставки
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {platforms.map((p, idx) => (
            <Link
              key={idx}
              to={p.to}
              className="flex items-start gap-4 p-5 rounded-2xl bg-background-100 hover:bg-primary-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 group"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${p.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors truncate">
                  {p.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{p.desc}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}